import { render } from "./HSpecColumnList.vue?vue&type=template&id=80666d70&scoped=true&ts=true"
import script from "./HSpecColumnList.vue?vue&type=script&lang=ts"
export * from "./HSpecColumnList.vue?vue&type=script&lang=ts"

import "./HSpecColumnList.vue?vue&type=style&index=0&id=80666d70&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80666d70"]])

export default __exports__